import React, { useEffect, useRef } from 'react'

//css
import './EnterpriseSecurity.scss'
import StickyHeader from '../Header/StickyHeader'
import Footer from '../Footer/Footer'
import images from '../../../../Assets/Images'
import CommonSecuritycontainer from './CommonSecuritycontainer/CommonSecuritycontainer'
import { useLocation } from 'react-router-dom'

const SecurityDetails = [
    { title: 'HIPPA', description: 'The Health Insurance Portability and Accountability Act of 1996 (HIPAA) is legislation that is designed to make it easier for US workers to retain health insurance coverage when they change or lose their jobs. The legislation also seeks to encourage electronic health records to improve the efficiency and quality of the US healthcare system through improved information sharing.', imgUrl: images.Hipaa, id: 'HIPPA Compliant' },
    { title: 'HITRUST', description: 'The HITRUST CSF (Cloud Security Framework) serves to unify security controls based on aspects of US federal law (such as HIPAA and HITECH), state law (such as Massachusetts’ Standards for the Protection of Personal Information of Residents of the Commonwealth) and recognized non-governmental compliance standards (such as PCI DSS) into a single framework that is tailored for healthcare needs.', imgUrl: images.Hitrust, id: 'HiTrust Compliant' },
    { title: 'HITECH', description: 'Health Information Technology for Economic and Clinical Health Act (HITECH) expanded the HIPAA rules in 2009. HIPAA and HITECH together establish a set of federal standards intended to protect the security and privacy of PHI.', imgUrl: images.Hitech, id: 'SOC2 Certified' },
    { title: 'FedRAMP', description: 'The Federal Risk and Authorization Management Program (FedRAMP) is a government-wide program that promotes the adoption of secure cloud services across the federal government by providing a standardized approach to security assessment, authorization, and continuous monitoring for cloud products and services.', imgUrl: images.Fedramp, id: 'FedRAMP Certified' },
    { title: 'AICPASOC', description: 'System and Organization Controls (SOC) Reports are independent third-party examination reports that demonstrate how powered by CentiBlick achieves key compliance controls and objectives. The purpose of these reports is to help you and your auditors understand the controls established to support operations and compliance.', imgUrl: images.AICPASOC, id: 'End-to-end Encryption' },
    { title: 'GDPR', description: 'The European Union’s General Data Protection Regulation (GDPR) protects European Union (EU) individuals’ fundamental right to privacy and the protection of personal data. The GDPR includes robust requirements that raise and harmonize standards for data protection, security, and compliance.', imgUrl: images.GDPR, id: 'GDPR Compliant' },
]

const EnterpriseSecurity = () => {

    const sectionRefs = useRef<any>(SecurityDetails.map(() => React.createRef()));
    const location = useLocation();

    useEffect(() => {
        if (location.state?.sectionId) {
            const sectionId = location.state?.sectionId;
            if (sectionId) {
                const sectionIndex = SecurityDetails.findIndex(security => security.id === sectionId);
                if (sectionIndex !== -1 && sectionRefs.current[sectionIndex]) {
                    const element = sectionRefs.current[sectionIndex].current;

                    if (element) {
                        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
                        const offsetPosition = elementPosition - 120;

                        window.scrollTo({
                            top: offsetPosition,
                            behavior: 'smooth',
                        });
                    }
                }
            }
        } else {
            window.scrollTo(0, 0);
        }
    }, [location.state]);


    return (
        <div className='enterprise-security'>
            <StickyHeader />
            <div className='security-main-div'>
                <CommonSecuritycontainer image={images.SecurityImage} title='Security & Trust' />
                <div className='securities common-container'>
                    {SecurityDetails?.map((security, index) => (
                        <div className='security-div'
                            key={index}
                            ref={sectionRefs.current[index]}>
                            <div>
                                <h1 className='security-title-header'>{security.title}</h1>
                            </div>
                            <div className='d-flex justify-content-between align-items-start security-details'>
                                <img src={security.imgUrl} alt="" />
                                <p>
                                    {security.description}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default EnterpriseSecurity